var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "signature-pad" }, [
    _c("canvas", {
      ref: "canvas",
      staticClass: "signature-pad__canvas",
      class: { "signature-pad__canvas--error": _vm.error },
      on: {
        pointerdown: _vm.start,
        pointermove: _vm.move,
        pointerup: _vm.end,
        pointerleave: _vm.end,
        pointercancel: _vm.end,
      },
    }),
    _c(
      "div",
      { staticClass: "d-flex justify-space-between align-center mt-1" },
      [
        _c("small", { staticClass: "grey--text" }, [
          _vm._v("Firmá con el dedo o con el mouse dentro del recuadro."),
        ]),
        _c(
          "v-btn",
          {
            attrs: {
              "x-small": "",
              text: "",
              color: "primary",
              disabled: _vm.empty,
            },
            on: { click: _vm.clear },
          },
          [_vm._v("Borrar")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }